import React from 'react'
import Svg from './../Svg'

export default ({
  width = 17,
  height = 17,
  'aria-label': ariaLabel,
  className = '',
}) =>
  <Svg
    className={ className }
    width={ width }
    height={ height }
    viewBox="0 0 1024 1024"
    aria-label={ ariaLabel }
  >
    <path d="M512.002 218.117v-60.117h118v-59c0-32.586-26.414-59-59.002-59h-176.998c-32.586 0-59 26.414-59 59v59h118v60.117c-198.018 15.063-354 180.507-354 382.383 0 211.8 171.7 383.5 383.5 383.5s383.5-171.7 383.5-383.5c0-201.874-155.982-367.318-354-382.383zM691.096 809.094c-55.722 55.72-129.798 86.406-208.594 86.406s-152.879-30.686-208.594-86.406c-55.72-55.72-86.406-129.8-86.406-208.594s30.686-152.879 86.406-208.594c53.505-53.503 123.943-83.908 199.229-86.238l-19.983 289.485c-1.715 24.235 11.489 34.847 29.351 34.847s31.063-10.612 29.351-34.847l-19.981-289.487c75.286 2.332 145.726 32.737 199.231 86.24 55.72 55.72 86.405 129.8 86.405 208.594s-30.686 152.879-86.405 208.594z"/>
  </Svg>
